<template>
  <div>
    <footer class="footer" :class="this.footer=='footer-dark'?'footer-dark':''">
      <div class="container-fluid">
        <div class="row">
          <div class="col-md-12 footer-copyright text-center">
            <p v-if="versionInfo" class="mb-0"><small>{{ versionInfo }}</small></p>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
  import json from '../data/menu';
  import { mapGetters } from 'vuex'
  export default {
    name: 'footerpage',
    data() {
      return {
        customizer: false,
        data:
          'dataFooter:text/json;charset=utf-8,' +
          encodeURIComponent(JSON.stringify(json)),
      };
    },
    computed:{
          ...mapGetters({
            footer: 'layout/footer'
          }),
          versionInfo() {
            const config = window.__APP_CONFIG__ || {};
            const ref = [config.WORKSPACE_GIT_BRANCH, config.WORKSPACE_GIT_COMMIT].filter(Boolean).join('@');
            const built = config.BUILD_TIMESTAMP ? `built ${config.BUILD_TIMESTAMP}` : '';
            const info = [ref, built].filter(Boolean).join(' · ');
            return info || `dev build · ${new Date().toISOString()}`;
          }
        }
  };
</script>
